module.exports = "https://99designs-start-assets.imgix.net/js/9b61884927a461cab69cce1fe8de5c17.png";